import ContentLoader from 'react-content-loader'
import styles from './styles.scss'

const USPSkeleton = () => (
  <div className="pdp__usp-container__loader__wrapper">
    <style jsx>{styles}</style>
    <ContentLoader
      uniquekey="pdp__usp-container__content-loader"
      speed={2}
      className="pdp__usp-container__loader__content"
      width={300}
      height={48}
      viewBox="0 0 300 160"
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
    >
      <rect x="48" y="9" rx="3" ry="3" width="410" height="6" />
      <rect x="48" y="24" rx="3" ry="3" width="178" height="6" />
      <rect x="48" y="40" rx="3" ry="3" width="280" height="6" />
      <circle cx="16" cy="20" r="16" />
    </ContentLoader>
  </div>
)

export default USPSkeleton
